import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ['item'];
  static values = { draggableSelector: String }

  connect() {
    let options = {
      handle: '.handle',
      animation: 150,
      onEnd: this.updatePositions.bind(this),
    };

    // allow skipping certain items in element
    if (this.hasDraggableSelectorValue) {
      options.draggable = this.draggableSelectorValue;
    }
    this.sortable = Sortable.create(this.element, options);
  }

  updatePositions(_event) {
    this.itemTargets.forEach((item, index) => {
      const inputWrapper = document.getElementById(item.dataset.sortItemsInputWrapperId);

      const positionInput = (inputWrapper || item).querySelector("[data-position]");
      if (positionInput) {
        positionInput.value = index + 1;
        positionInput.dispatchEvent(new Event('change'))
      }
    });
  }
}
